import { page, router as inertiaRouter } from '@inertiajs/svelte'
import { on } from 'shared/javascripts/util/events'
import {
  initNativeAppBridge,
  type NativeAppBridge,
  type NativeAppRouter,
} from 'frontend/shared/javascripts/native_app/bridge'

function syncActiveTab(router: NativeAppRouter): () => void {
  return inertiaRouter.on('navigate', (event) => {
    const chrome = event.detail.page.props.native_app
    router.highlight(chrome ? chrome.section : null)
  })
}

// The app's back button and gesture follow the page's back link, as the top bar's arrow does.
function followBackLink(): () => void {
  return on(document, 'native_app.go_back', (event: Event) => {
    const backHref = page.props.native_app ? page.props.native_app.back_href : null
    if (backHref) {
      event.preventDefault()
      inertiaRouter.visit(backHref)
    }
  })
}

export function initInertiaNativeAppBridge(): NativeAppBridge {
  const bridge = initNativeAppBridge({
    // Not `inertiaRouter.visit`: the tab-bar targets are Unpoly pages, which Inertia would reject.
    visit(path) {
      window.location.assign(path)
    },

    currentLocation() {
      return window.location.pathname + window.location.search
    },

    dismissOverlay() {
      return false
    },
  })

  const stopSyncingActiveTab = syncActiveTab(bridge.router)
  const stopFollowingBackLinks = followBackLink()

  return {
    ...bridge,
    destroy() {
      stopSyncingActiveTab()
      stopFollowingBackLinks()
      bridge.destroy()
    },
  }
}
